export default "/_next/static/images/community-topbanner-Bg-e6b58f883536df6e62c7e4df5cd1a81a.jpg";